export default __webpack_public_path__ + "static/media/Lightsaber Luke ROTJ - Img - Wip 3_11.1d15d46b.jpg";